module.exports = __webpack_public_path__ + "static/media/logo-twitter.3ee3ca38.svg";